import React, { useState } from 'react';
import { cn } from '../lib/utils';
import Header from '../Components/Common/Header';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from '../Components/Common/Sidebar';
import Footer from '../Components/Common/Footer';

const SIDEBAR_COOKIE_NAME = "sidebar_state";
const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days

const Layout = ({ children }) => {
  /*
  // Cookie-based state initialization
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${SIDEBAR_COOKIE_NAME}=`);
    if (parts.length === 2) {
      const cookieVal = parts.pop().split(';').shift();
      return cookieVal === 'true';
    }
    return true;
  });
  */

  // LocalStorage-based state initialization (Fallback)
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem('sidebarOpen');
    return savedState !== null ? JSON.parse(savedState) : true;
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(prev => {
      const newState = !prev;
      
      /*
      // Cookie-based save
      document.cookie = `${SIDEBAR_COOKIE_NAME}=${newState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
      */
      
      // LocalStorage-based save (Fallback)
      localStorage.setItem('sidebarOpen', JSON.stringify(newState));
      
      return newState;
    });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex overflow-hidden">
      {/* Persistent Sidebar */}
      <div className={cn("w-64 shrink-0 transition-all duration-300", !isSidebarOpen && "w-0")}>
        <Sidebar isVisible={isSidebarOpen} toggleSidebar={toggleSidebar} />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden relative z-20">
        <Header toggleSidebar={toggleSidebar} />

        <main className="flex-1 overflow-y-auto scroll-smooth bg-[#F7F4EA]">
          <div className="animate-in fade-in duration-500">
            {children}
          </div>
        </main>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default Layout;
